import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  typography: {
    fontFamily: "Lato, Roboto, Arial, sans-serif",
  },
});
